(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.ElevateLifeAssets.Default",
                {
                    url: "/Default",
                    component: "elevatelifeassetsdefault",
                    PageTitle: "Elevate for Life",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("elevatelifeassetsdefault",
        {
            templateUrl: "App/Tools/MarketPlace/ElevateLifeAssets/Default/Default.html",
            controller: elevateLifeAssetsDefaultCtrl,
            bindings: {
                states: "<"
            }
        });

    elevateLifeAssetsDefaultCtrl.$inject = ["ssoApi", "externalLoading"];
    function elevateLifeAssetsDefaultCtrl(ssoApi, externalLoading) {
        var $ctrl = this;



        this.ActivateElevate4LifeSso = function () {
            var w = window.open();
            w.document.write(externalLoading.html);
            ssoApi.initiateElevate4LifeSso().then(function (data) {
                //console.log(data);
                w.document.write(data);
                w.document.forms.platinum.submit();
            }, function () {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        };
        $ctrl.goToCreativeServicesfunction = function () {

            // redirectToMarketplace("CreativeServices");

            var w = window.open();
            w.document.write(externalLoading.html);
            ssoApi.initiateCreativeServicesSso().then(function (data) {
                //console.log(data);
                w.document.write(data);
                w.document.forms.platinum.submit();
            }, function () {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }
    }
})(window.app, window.angular); // jshint ignore:line